import React from 'react'
import { Button, Modal } from '@tecsinapse/cortex-react'
import { useRenomearDialog } from '../hooks/use-renomear-dialog'
import { FormProvider, useFormState } from 'react-hook-form'
import { FormTextField } from '../../hook-form-connectors/form-text-field'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'
import { BibliotecaDialogProps } from '../types/types'

export const RenomearDialog = ({
  open,
  close,
  pastaAtual
}: BibliotecaDialogProps) => {
  const { form, onSubmit, closeForm } = useRenomearDialog({
    pastaAtual,
    close
  })
  const { handleSubmit, control } = form
  const { isSubmitting, isDirty } = useFormState({ control })

  return (
    <FormProvider {...form}>
      <Modal onClose={closeForm} open={open}>
        <div
          className={'w-[20rem] flex flex-col items-start'}
          data-testid='renomear'
        >
          <p className={'text-h3 font-bold mb-deca'}>
            <Trans>Renomear</Trans>
          </p>

          <form onSubmit={handleSubmit(onSubmit)} className={'w-full'}>
            <FormTextField name='novoNome' label={t`Novo Nome`} />

            <div
              className={'flex flex-row items-center justify-between mt-deca'}
            >
              <Button
                disabled={isSubmitting}
                onClick={closeForm}
                variants={{ variant: 'outline' }}
              >
                <Trans>Cancelar</Trans>
              </Button>
              <Button disabled={isSubmitting || !isDirty} type={'submit'}>
                <Trans>Renomear</Trans>
              </Button>
            </div>
          </form>
        </div>
      </Modal>
    </FormProvider>
  )
}
